export default () => ({
    loading: true,
    activities: null,
    currentActivity: null,
    activityTypes: [],
    totalItems: 0,
    getTotalItemsParticipants: 0,
    errorMessageTranslate: null,
})